import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSelectChange } from '@angular/material';
import { ConstantsUtils } from '../../../core/utils/constants-utils';

@Component({
	selector: 'kt-alert',
	templateUrl: './dialog-order-billing.component.html',
	styleUrls: ['./dialog-order-billing.component.scss']
})
export class DialogOrderBillingComponent {

    @ViewChild('textarea') textarea;
    observationDebtType = ConstantsUtils.observationDebtType;
    private selection: any;

	constructor(
		public dialogRef: MatDialogRef<DialogOrderBillingComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: AlertData) {
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	ok() {
	    if (this.data.text) {
            this.dialogRef.close({
                result: 'ok',
                selection: this.selection,
            });
        } else {
            this.dialogRef.close('ok');
        }
	}

    selectionChange($event: MatSelectChange) {
        this.selection = $event.value;
    }
}

export interface AlertData {
	title: string;
	mensaje: string;
	text: boolean;
}
